// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".faIcon--2IYQpP5k.svg-inline--fa {\n  width: 1em;\n}\n\n.roundSquareBg--1bgTDK6y {\n  border-radius: 10%;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"faIcon": "faIcon--2IYQpP5k",
	"roundSquareBg": "roundSquareBg--1bgTDK6y"
};
export default ___CSS_LOADER_EXPORT___;
